import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { CommonLabelAndValueList } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';

const NominationNameSectionImpl: React.FC = () => {
  const {
    reviewAndSubmitNominationPageUiStore,
  } = useStores();

  return (
    <FlexBox
      wrap
      isFullWidth
      as='section'
      className='nomination-section'
    >
      <Text
        as='h3'
        block
        weight='semibold'
        size={400}
      >
        Your information
      </Text>
      <FlexBox
        isFullWidth
        direction='column'
        className='nomination-section__list'
      >
        <FlexBox
          isFullWidth 
          aligns='start'
        >
          <CommonLabelAndValueList
            label='Solution name:'
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNomination?.name}
          />
        </FlexBox>
        <FlexBox
          isFullWidth
          aligns='start'
        >
          <CommonLabelAndValueList
            label='Prefix:'
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNomination?.owner?.prefix}
          />
          <CommonLabelAndValueList
            label='First name:'
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNomination?.owner?.firstName}
          />
        </FlexBox>
        <FlexBox
          isFullWidth
          aligns='start'
        >
          <CommonLabelAndValueList
            label='Last name:'
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNomination?.owner?.lastName}
          />
          <CommonLabelAndValueList
            label='Title / Role:'
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNomination?.owner?.title}
          />
        </FlexBox>
        <FlexBox
          isFullWidth
          aligns='start'
        >
          <CommonLabelAndValueList
            label='Email:'
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNomination?.owner?.emailAddress}
          />
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
}

export const NominationNameSection = observer(NominationNameSectionImpl);
